import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { ConfigurationSettingsDto } from 'src/core/models/configuration-setting/configuration-settings.dto';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';

@Component({
  selector: 'ca-ask-manager-settings',
  templateUrl: './ask-manager-settings.component.html',
  styleUrls: ['./ask-manager-settings.component.scss'],
  standalone: false,
})
export class AskManagerSettingsComponent implements OnDestroy {
  settingsForm: FormGroup;

  private readonly settingKeyAskManagerEnabled = 'AgentAssist.AskManagerEnabled';
  private readonly destroy$ = new Subject<void>();

  constructor(
    private config: ConfigStateService,
    private fb: FormBuilder,
    private settingService: ConfigurationSettingsService,
    private toastr: ToasterService,
    private localizationService: LocalizationService
  ) {
    this.settingsForm = this.fb.group({
      askManagerEnabled: [
        this.config.getSetting(this.settingKeyAskManagerEnabled)?.toLowerCase() === 'true',
      ],
    });
  }

  onSubmitSettings(): void {
    const settings: ConfigurationSettingsDto[] = [
      {
        settingName: this.settingKeyAskManagerEnabled,
        settingValue: String(!!this.settingsForm.get('askManagerEnabled').value),
      },
    ];

    this.settingService
      .saveSetting(settings)
      .pipe(
        switchMap(() => this.config.refreshAppState()),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.toastr.success(
          this.localizationService.instant('AbpSettingManagement::SavedSuccessfully')
        );
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
